<template>
    <v-app id="inspire">
        <div id="bglogin" style="position: absolute;top: 0"></div>
        <v-content>
            <v-container fluid fill-height>
                <v-layout align-center justify-center>
                    <v-flex xs10 sm8 md4>
                        <v-card class="elevation-0">
                            <v-card-text>
                                <v-form>
                                    <v-text-field autocomplete="off" name="login" label="Usuário" type="text"
                                                  v-model="dados.username"/>
                                    <v-text-field name="password" label="Senha" id="password"
                                                  type="password" v-model="dados.password"/>
                                </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer/>
                                <v-btn color="primary" @click.stop="logar()">Login</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>
<script>
    import { Me } from "../class/me";
    import axios from "axios";
    import { Ordens } from "../class/ordens";
    import { EventBus } from "../utils/event-bus.js";

    export default {
        data () {
            return {
                snackbar: false,
                dados: {
                    username: null,
                    password: null
                }
            };
        },
        methods: {
            logar: async function () {
                try {
                    Ordens.clear();

                    let response = await Me.autentica(this.dados);
                    // console.log(response.data);
                    await Me.add(response.data);

                    EventBus.$emit("login", true);

                    axios.defaults.headers.common["Authorization"] = "JWT " + response.data.token;
                    this.$router.push("/list-ordens");
                } catch (err) {
                    console.error(err);
                    this.snackbar = true;
                }
            }
        }
    };
</script>

<style scoped>
    #bglogin {
        background: url('/img/login.jpg') fixed;
        background-size: cover;
        padding: 0;
        margin: 0;
        height: 100%;
        width: 100%;
    }
</style>
